import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import '../styles/searchBar.css';
import hero from '../images/hero-bg.svg';
import {CustomButton} from './CustomButton';
import CustomRadioButton from './CustomRadioButton';
import CustomInput from './CustomInput';
import {FormattedMessage} from 'react-intl';
import {injectIntl} from 'react-intl';
import {CustomCheckbox} from './CustomCheckbox';
import NewComboboxSearch from './NewCombobox';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameorid: '',
      businessType: null,
      disableButtons: true,
      businessFilter: 'MainArea',
      registryType: 'registered'
    };
  }

  onChangeSearchInput = e =>
    this.setState({
      nameorid: e.target.value
    });

  onChangeComboBox = e => {
    let searchType = 'businessType';
    let value = e;
    this.setState({businessType: e});
    const object = {
      searchType,
      value
    };
    this.showButtons(object);
  };

  onChangeBusinessFilter = (filterName, isChecked, e) => {
  let {businessFilter} = this.state;

  if (filterName === 'MainArea') {
    if (isChecked) {
      businessFilter = businessFilter === 'SideArea' ? 'both' : 'MainArea';
    } else {
      businessFilter = 'SideArea';
    }
  }

  if (filterName === 'SideArea') {
    if (isChecked) {
      businessFilter = businessFilter === 'MainArea' ? 'both' : 'SideArea';
    } else {
      businessFilter = 'MainArea';
    }
  }

    this.setState({businessFilter});
  };

  updateUrl = () => {
    const {nameorid, businessFilter, businessType, registryType} = this.state;
    this.props.history.push({
      pathname: '/yritykset',
      search: `?nameorid=${nameorid}?businessFilter=${businessFilter}?businesstype=${
        businessType ? businessType.value : ''
      }?registryType=${registryType || 'registered'}`
    });
  };

  onSubmit = e => {
    e.preventDefault();
    const {nameorid, businessType, businessFilter, registryType} = this.state;
    this.updateUrl();
    this.props.onSearch(nameorid, businessType, businessFilter, registryType);
  };

  onRegistryTypeChanged = value =>
    this.setState({
      registryType: value
    });

  showButtons(object) {
    if (object.value) {
      this.setState({disableButtons: false});
    } else {
      this.setState({disableButtons: true, businessFilter: 'both'});
    }
  }

  render() {
    const {formatMessage} = this.props.intl;

    return (
      <div
        style={{
          backgroundColor: '#EAECE2',
          width: '100%',
          height: 'auto',
          paddingBottom: '2rem',
          backgroundImage: `url(${hero})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right bottom',
          backgroundSize: '300px auto',
          paddingTop: '48px',
          paddingLeft: '80px'
        }}
      >
        <form onSubmit={this.onSubmit}>
          <h1 className="h1">
            <FormattedMessage id="search-bar-title" />
          </h1>
          <p className="body-lg" style={{maxWidth: '768px', marginBottom: '24px'}}>
            <FormattedMessage id="registry-text" />
          </p>
          <h2 className="h2" style={{marginBottom: '1rem'}}>
            <FormattedMessage id="search-from-register" />
          </h2>
          <CustomInput onChange={this.onChangeSearchInput} />

          <NewComboboxSearch
            language={this.props.language}
            onChange={this.onChangeComboBox}
            value={this.state.businessType}
          />
          <div
            style={{
              marginTop: '1rem',
              display: 'flex',
              gap: '2rem'
            }}
          >
            <CustomRadioButton
              label={formatMessage({id: 'registered'})}
              id="registered"
              name="type"
              value="registered"
              checked={this.state.registryType === 'registered'}
              onChange={() => this.onRegistryTypeChanged('registered')}
            />
            <CustomCheckbox
              label={formatMessage({id: 'search_bar-mainbusiness'})}
              id="mainbusiness"
              name="businessFilter"
              value="MainArea"
              checked={
                this.state.businessFilter === 'MainArea' || this.state.businessFilter === 'both'
              }
              onChange={e => this.onChangeBusinessFilter('MainArea', e)}
              disableButtons={this.state.disableButtons}
            />
          </div>
          <div
            style={{
              display: 'flex',
              gap: '2rem',
              marginBottom: '1.4rem',
              marginTop: '0.4rem'
            }}
          >
            <CustomRadioButton
              label={formatMessage({id: 'deleted'})}
              id="deleted"
              name="type"
              value="deleted"
              checked={this.state.registryType === 'deleted'}
              onChange={() => this.onRegistryTypeChanged('deleted')}
            />
            <CustomCheckbox
              label={formatMessage({id: 'search_bar-sidebusiness'})}
              id="sidebusiness"
              name="businessFilter"
              value="SideArea"
              checked={
                this.state.businessFilter === 'SideArea' || this.state.businessFilter === 'both'
              }
              onChange={e => this.onChangeBusinessFilter('SideArea', e)}
              disableButtons={this.state.disableButtons}
            />
          </div>
          <CustomButton className="button primary" type="submit">
            <FormattedMessage id="search" />
          </CustomButton>
        </form>
      </div>
    );
  }
}

Search.propTypes = {
  onSearch: PropTypes.func.isRequired,
  history: PropTypes.any
};

export default withRouter(injectIntl(Search));
